/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PermissionEntraGroupSyncSummaryResponse
 */
export interface PermissionEntraGroupSyncSummaryResponse {
    /**
     * 
     * @type {any}
     * @memberof PermissionEntraGroupSyncSummaryResponse
     */
    permissionId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionEntraGroupSyncSummaryResponse
     */
    permissionMappedToGroup?: boolean;
    /**
     * 
     * @type {any}
     * @memberof PermissionEntraGroupSyncSummaryResponse
     */
    added?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PermissionEntraGroupSyncSummaryResponse
     */
    skipped?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PermissionEntraGroupSyncSummaryResponse
     */
    failed?: any | null;
}

/**
 * Check if a given object implements the PermissionEntraGroupSyncSummaryResponse interface.
 */
export function instanceOfPermissionEntraGroupSyncSummaryResponse(value: object): value is PermissionEntraGroupSyncSummaryResponse {
    return true;
}

export function PermissionEntraGroupSyncSummaryResponseFromJSON(json: any): PermissionEntraGroupSyncSummaryResponse {
    return PermissionEntraGroupSyncSummaryResponseFromJSONTyped(json, false);
}

export function PermissionEntraGroupSyncSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionEntraGroupSyncSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'permissionId': json['permissionId'] === undefined ? undefined : json['permissionId'] === null ? null : json['permissionId'],
        'permissionMappedToGroup': json['permissionMappedToGroup'] == null ? undefined : json['permissionMappedToGroup'],
        'added': json['added'] === undefined ? undefined : json['added'] === null ? null : json['added'],
        'skipped': json['skipped'] === undefined ? undefined : json['skipped'] === null ? null : json['skipped'],
        'failed': json['failed'] === undefined ? undefined : json['failed'] === null ? null : json['failed'],
    };
}

export function PermissionEntraGroupSyncSummaryResponseToJSON(json: any): PermissionEntraGroupSyncSummaryResponse {
    return PermissionEntraGroupSyncSummaryResponseToJSONTyped(json, false);
}

export function PermissionEntraGroupSyncSummaryResponseToJSONTyped(value?: PermissionEntraGroupSyncSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissionId': value['permissionId'],
        'permissionMappedToGroup': value['permissionMappedToGroup'],
        'added': value['added'],
        'skipped': value['skipped'],
        'failed': value['failed'],
    };
}

